"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGCard = exports.CTGTapRequirement = exports.CTGColor = exports.CTGSuit = exports.CTGRank = void 0;
const KHEventHandler_1 = require("../KH/KHEventHandler");
var CTGRank;
(function (CTGRank) {
    CTGRank[CTGRank["Ace"] = 1] = "Ace";
    CTGRank[CTGRank["Two"] = 2] = "Two";
    CTGRank[CTGRank["Three"] = 3] = "Three";
    CTGRank[CTGRank["Four"] = 4] = "Four";
    CTGRank[CTGRank["Five"] = 5] = "Five";
    CTGRank[CTGRank["Six"] = 6] = "Six";
    CTGRank[CTGRank["Seven"] = 7] = "Seven";
    CTGRank[CTGRank["Eight"] = 8] = "Eight";
    CTGRank[CTGRank["Nine"] = 9] = "Nine";
    CTGRank[CTGRank["Ten"] = 10] = "Ten";
    CTGRank[CTGRank["Jack"] = 11] = "Jack";
    CTGRank[CTGRank["Queen"] = 12] = "Queen";
    CTGRank[CTGRank["King"] = 13] = "King";
})(CTGRank = exports.CTGRank || (exports.CTGRank = {}));
var CTGSuit;
(function (CTGSuit) {
    CTGSuit[CTGSuit["Hearts"] = 1] = "Hearts";
    CTGSuit[CTGSuit["Diamonds"] = 2] = "Diamonds";
    CTGSuit[CTGSuit["Clubs"] = 3] = "Clubs";
    CTGSuit[CTGSuit["Spades"] = 4] = "Spades";
})(CTGSuit = exports.CTGSuit || (exports.CTGSuit = {}));
var CTGColor;
(function (CTGColor) {
    CTGColor[CTGColor["Red"] = 1] = "Red";
    CTGColor[CTGColor["Black"] = 2] = "Black";
})(CTGColor = exports.CTGColor || (exports.CTGColor = {}));
var CTGTapRequirement;
(function (CTGTapRequirement) {
    CTGTapRequirement[CTGTapRequirement["Dont"] = 0] = "Dont";
    CTGTapRequirement[CTGTapRequirement["Must"] = 1] = "Must";
    CTGTapRequirement[CTGTapRequirement["Whatever"] = 2] = "Whatever";
})(CTGTapRequirement = exports.CTGTapRequirement || (exports.CTGTapRequirement = {}));
let CTGCard = /** @class */ (() => {
    class CTGCard extends KHEventHandler_1.KHEventHandler {
        constructor(suit, rank, tapRequirement) {
            super([CTGCard.EVENT_MOVE, CTGCard.EVENT_DESTROY, CTGCard.EVENT_FLIP,
                CTGCard.EVENT_TAPPED, CTGCard.EVENT_LEFT_SCREEN, CTGCard.EVENT_SELECT,
                CTGCard.EVENT_INVALID_PRESS, CTGCard.EVENT_CAN_INTERACT, CTGCard.EVENT_ALPHA]);
            this.x = 0;
            this.y = 0;
            this.rot = 0;
            this.alpha = 1;
            if (!Number.isInteger(rank) || !Number.isInteger(suit)) {
                console.trace("Bad card created.", this);
            }
            this.rank = rank;
            this.suit = suit;
            this._can_interact = true;
            this.showing_front = true;
            this.is_selected = false;
            this.tap_requirement = tapRequirement === undefined ? CTGTapRequirement.Whatever : tapRequirement;
        }
        isBlack() {
            return this.suit == CTGSuit.Spades || this.suit == CTGSuit.Clubs;
        }
        isRed() {
            return !this.isBlack();
        }
        color() {
            return this.isRed() ? CTGColor.Red : CTGColor.Black;
        }
        number() {
            return (this.suit - 1) * 13 + (this.rank - 1);
        }
        blackjackMinValue() {
            if (this.rank < CTGRank.Jack)
                return this.rank;
            return CTGRank.Ten;
        }
        imageId() {
            return "c" + this.number();
        }
        equals(other) {
            return this.suit == other.suit && this.rank == other.rank;
        }
        flip(show_front, animate) {
            if (this.showing_front == show_front)
                return;
            this.showing_front = show_front;
            this.emitEvent(CTGCard.EVENT_FLIP, { card: this, show_front: show_front, animate: animate });
        }
        move(x, y) {
            this.x = x;
            this.y = y;
            this.emitEvent(CTGCard.EVENT_MOVE, { card: this, x: x, y: y });
        }
        set_alpha(alpha) {
            this.alpha = alpha;
            this.emitEvent(CTGCard.EVENT_ALPHA, { card: this });
        }
        tapped() {
            this.emitEvent(CTGCard.EVENT_TAPPED, { card: this });
        }
        set_selected(is_selected, audio) {
            this.is_selected = is_selected;
            this.emitEvent(CTGCard.EVENT_SELECT, { card: this, selected: this.is_selected, audio: audio });
        }
        invalid_press() {
            this.emitEvent(CTGCard.EVENT_INVALID_PRESS, { card: this });
        }
        set_can_interact(can_interact) {
            this._can_interact = can_interact;
            this.emitEvent(CTGCard.EVENT_CAN_INTERACT, { can_interact: can_interact });
        }
        can_interact() {
            return this._can_interact;
        }
        destroy(animate, play_sound = animate, after_flip = false) {
            if (this.destroyed)
                return;
            if (this.is_selected) {
                this.set_selected(false, false);
            }
            this.destroyed = true;
            this.emitEvent(CTGCard.EVENT_DESTROY, { card: this, animate: animate, play_sound: play_sound, after_flip: after_flip });
            this.unregisterAllCallbacks();
        }
        static deck() {
            let cards = [];
            for (let i = 0; i < 52; i++) {
                cards.push(CTGCard.fromNumber(i));
            }
            return cards;
        }
        static randomCard(rand) {
            return new CTGCard(rand.getRandomEnum(CTGSuit), rand.getRandomEnum(CTGRank));
        }
        /**
         * Generates a random card with optional fixed parameters. If color and suit
         * are both provided, it will honor the suit.
         * @param fixedColor
         * @param fixedSuit
         * @param fixedRank
         */
        static randomFixedCard(rand, fixedColor, fixedSuit, fixedRank) {
            let rank;
            let suit;
            if (fixedColor !== undefined) {
                if (fixedColor == CTGColor.Red) {
                    suit = rand.getRandom([CTGSuit.Hearts, CTGSuit.Diamonds]);
                }
                else {
                    suit = rand.getRandom([CTGSuit.Spades, CTGSuit.Clubs]);
                }
            }
            if (fixedSuit !== undefined) {
                suit = fixedSuit;
            }
            if (fixedRank !== undefined) {
                rank = fixedRank;
            }
            if (suit === undefined) {
                suit = rand.getRandomEnum(CTGSuit);
            }
            if (rank === undefined) {
                rank = rand.getRandomEnum(CTGRank);
            }
            return new CTGCard(suit, rank);
        }
        static randomSuit(rand, fixedColor) {
            return rand.getRandom(fixedColor == CTGColor.Black ?
                [CTGSuit.Spades, CTGSuit.Clubs] :
                [CTGSuit.Diamonds, CTGSuit.Hearts]);
        }
        static randomCardWithBlackjackValue(rand, value) {
            if (value < 10) {
                return CTGCard.randomFixedCard(rand, undefined, undefined, value);
            }
            else if (value == 10) {
                return new CTGCard(rand.getRandomEnum(CTGSuit), rand.getRandom([CTGRank.Ten, CTGRank.Jack, CTGRank.Queen, CTGRank.King]));
            }
            else {
                return CTGCard.randomFixedCard(rand, undefined, undefined, CTGRank.Ace);
            }
        }
        static fromNumber(num) {
            return new CTGCard(Math.floor(num / 13) + 1, (num % 13) + 1);
        }
        charForRank() {
            switch (this.rank) {
                case CTGRank.Ace: return 'A';
                case CTGRank.Two: return '2';
                case CTGRank.Three: return '3';
                case CTGRank.Four: return '4';
                case CTGRank.Five: return '5';
                case CTGRank.Six: return '6';
                case CTGRank.Seven: return '7';
                case CTGRank.Eight: return '8';
                case CTGRank.Nine: return '9';
                case CTGRank.Ten: return 'T';
                case CTGRank.Jack: return 'J';
                case CTGRank.Queen: return 'Q';
                case CTGRank.King: return 'K';
                default: return '?';
            }
        }
        charForSuit() {
            switch (this.suit) {
                case CTGSuit.Clubs: return '♣';
                case CTGSuit.Diamonds: return '♦';
                case CTGSuit.Hearts: return '♥';
                case CTGSuit.Spades: return '♠';
                default: return '?';
            }
        }
        toString() {
            return this.charForRank() + this.charForSuit();
        }
    }
    CTGCard.EVENT_MOVE = "m";
    CTGCard.EVENT_DESTROY = "d";
    CTGCard.EVENT_FLIP = "f";
    CTGCard.EVENT_TAPPED = "t";
    CTGCard.EVENT_LEFT_SCREEN = "ls";
    CTGCard.EVENT_SELECT = "s";
    CTGCard.EVENT_INVALID_PRESS = "ip";
    CTGCard.EVENT_CAN_INTERACT = "ci";
    CTGCard.EVENT_ALPHA = "a";
    return CTGCard;
})();
exports.CTGCard = CTGCard;
